
import { defineComponent, PropType, computed } from "vue";
export default defineComponent({
  name: "CheckboxesGroup",
  props: {
    input: { type: Object as PropType<any>, required: true },
    options: { type: Array as PropType<any[]>, default: () => [] },
    values: { type: Object as PropType<Record<string, any>>, required: true },
    modelValue: { type: Array as PropType<string[]>, default: () => [] },
  },
  emits: ["update:modelValue"],
  setup(props, { emit }) {
    const visible = computed(() => !props.input.hideIfChecked || !props.values[props.input.hideIfChecked]);
    const model = computed({
      get: () => props.modelValue,
      set: (v) => emit("update:modelValue", v),
    });
    return { visible, model };
  },
});
